import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Accept, CancelButton } from "../pages/css components/Button";

export default function EditButtons({
  path,
  formikProps,
  editState,
  setEditState,
  edit = false,
  showBackButton = true,
}) {
  const navigate = useNavigate();

  function handleCancel() {
    if (path) {
      navigate(path);
    }
    if (edit === true) {
      setEditState(!editState);
    }

    if (edit === true && !editState) {
      navigate(-1);
    }

    if (!path && !edit) {
      navigate(-1);
    }
  }

  return (
    <Fragment>
      {showBackButton && (
        <CancelButton variant="outlined" onClick={handleCancel}>
          Back
        </CancelButton>
      )}

      {!editState && formikProps?.values?.status !== "ACTIVE" && (
        <Accept
          style={{ marginLeft: "5px" }}
          size="large"
          variant="contained"
          onClick={() => setEditState(!editState)}
        >
          Edit
        </Accept>
      )}
    </Fragment>
  );
}
